export default __webpack_public_path__ + "static/media/Roboto-Light.00fc594b.ttf";